import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import '../../../Assets/Css/TaskEmployees.scss';
import Select from "react-select";
import { customStyle } from '../../../Components/Style';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../../Lib/RoleWiseFeatureWrapper';
import Drag_Drop from "../../../Assets/Images/Employee/Drag_Drop"
import Summery from "../../../Assets/Images/Employee/Summery"
import Table from '../../../Components/Table';
import CustomCalendar from '../../../Components/CustomCalendar';
import { connect } from 'react-redux';
import { getFilteredTasks, getTaskStatus, updateTask, getTasks } from '../../../Services/Task/action';
import { getTime } from '../../../Lib/utils';
import moment from 'moment';
import ModulesList from '../../../Assets/ModulesLiist';
import FeaturesList from '../../../Assets/FeaturesList';
import { Spinner } from 'react-bootstrap';
import { exportData } from '../../../Lib/exportData';
import { toast } from 'react-toastify';
import useTimerStore from '../../../Lib/timerStore';
import { getprojects } from '../../../Services/Project/action';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import '../../../Assets/Css/EmployeeDragable.scss'
import { deleteRecord } from '../../../Services/Delete/action';

const header = [
    { field: "checkbox" },
    { field: "Code" },
    { field: "Timer" },
    { field: "Time" },
    { field: "Task" },
    { field: "Project" },
    { field: "Due Date" },
    { field: "Hours Logged" },
    { field: "Assigned To" },
    { field: "Status" },
    { field: "Action" },
];

const TaskEmployees = ({ filteredTasks, getFilteredTasks, user, modules, features, updateTask, updateTaskTimerData, getTaskStatus, taskStatus, project, getprojects, task, getTasks, deleteRecord }) => {
    const [viewChange, setViewChange] = useState("Table");
    const [inData, setInData] = useState([]);
    const [checked, setChecked] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [params, setParams] = useState({});
    const [selectedId, setSelectedId] = useState([]);
    const [dateStatus, setDateStatus] = useState(false);
    const [filteredStartDate, setFilteredStartDate] = useState(null);
    const [filteredEndDate, setFilteredEndDate] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const { getTimerState } = useTimerStore();
    const { employeeId } = useParams();
    const [columns, setColumns] = useState({});

    const canEdit = checkFeatureAccess({
        modules: modules,
        features: features,
        user: user,
        ModuleName: ModulesList.Task,
        Featur_Name: FeaturesList.Update,
    });

    const canView = checkFeatureAccess({
        modules: modules,
        features: features,
        user: user,
        ModuleName: ModulesList.Task,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: modules,
        features: features,
        user: user,
        ModuleName: ModulesList.Task,
        Featur_Name: FeaturesList.Delete,
    });

    const initialState = {
        status: { value: 'Hide Completed Task', label: 'Hide Completed Task' },
        project: '',
    };

    const [initialData, setInitialData] = useState(initialState);
    const [activeButton, setActiveButton] = useState("");

    const navigate = useNavigate();
    let footer = true;
    let count = inData?.length;

    useEffect(() => {
        getFilteredTasks(employeeId);
        getTaskStatus();
        getprojects();
        getTasks();
    }, []);

    useEffect(() => {
        if (location.pathname?.includes(`/employees/view/${employeeId}/task`)) {
            setActiveButton(location.pathname.slice(18))
        } else if (location.pathname?.includes(`/employees/view/${employeeId}/taskboards`)) {
            setActiveButton(location.pathname.slice(23))
        }
    }, []);

    const handleClickBtn = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
        console.log(buttonId, "name button")
    };

    const isTimerRunning = (users, currentUserId, currentUserRole, allTasks) => {
        const assignedUserIds = users?.map(u => u?.id) || [];
        const allRunningTimers = allTasks
            ?.flatMap(task => task?.task?.taskTimerMap || [])
            ?.filter(timer => timer?.state !== "stopped");

        if (assignedUserIds?.includes(currentUserId) && currentUserRole === "hr_senior" && employeeId == currentUserId) {
            return allRunningTimers?.some(t => t?.employee_id === currentUserId);
        }
        return allRunningTimers.some(t => employeeId == t?.employee_id && t?.state != "stopped");
    };

    useEffect(() => {
        const updatedTimers = {};
        const validKeys = new Set();

        filteredTasks?.forEach((item) => {
            const allTimers = item?.task?.taskTimerMap;

            allTimers?.forEach((timer) => {
                const key = `${timer.employee_id}_${timer.task_id}`;
                validKeys.add(key);

                if (
                    !updatedTimers[key] ||
                    timer.id > (updatedTimers[key].id || 0)
                ) {
                    const { time } = getTime(timer.start_time, new Date(), typeof timer.action_history === "string"
                                  ? JSON.parse(timer.action_history)
                                  : timer.action_history || []);
                    updatedTimers[key] = {
                        taskId: timer.task_id,
                        startTime: timer.start_time,
                        status: timer?.state,
                        actionHistory:
                            typeof timer.action_history === "string"
                                ? JSON.parse(timer.action_history)
                                : timer.action_history || [],
                        timer:time
                    };
                }
            });
        });

        const filteredExistingTimers = Object.fromEntries(
            Object.entries(useTimerStore.getState().timers).filter(
                ([key]) => validKeys.has(key)
            )
        );

        const sanitizedTimers = Object.fromEntries(
            Object.entries(updatedTimers).map(([key, value]) => {
                const { id, ...rest } = value;
                return [key, rest];
            })
        );

        useTimerStore.setState({
            timers: {
                ...filteredExistingTimers,
                ...sanitizedTimers,
            },
        });

        setInData(filteredTasks?.map((employee) => {
            const taskTimers = employee?.task?.taskTimerMap?.[0];
            const allTimers = employee?.task?.taskTimerMap;

            const actionHistory = typeof taskTimers?.action_history === "string"
                ? JSON.parse(taskTimers?.action_history)
                : taskTimers?.action_history || [];
            const { time, hoursLogged } = getTime(
                taskTimers?.start_time,
                taskTimers?.stop_time,
                actionHistory,
            )
            let totalElapsedTime = 0;
            allTimers?.forEach(async (timer) => {

                if (timer?.duration) {
                    const [hh, mm, ss] = timer?.duration?.split(/[hms\s]+/).filter(Boolean).map(Number);
                    totalElapsedTime += hh * 3600 + mm * 60 + ss;
                }

            });

            const totalH = Math.floor(totalElapsedTime / 3600);
            const totalM = Math.floor((totalElapsedTime % 3600) / 60);
            const totalS = totalElapsedTime % 60;
            const totalHoursLogged = `${totalH}h ${totalM}m ${totalS}s`;

            return {
                "checkbox": {
                    value: employee?.task?.id,
                    value2: employee?.task?.taskTimerMap?.find(timer => timer?.state != "stopped")?.id,
                    type: "checkbox",
                },
                "Code": {
                    value: `CD_${employee?.task?.id}`,
                    type: "text"
                },
                Timer: (() => {
                    if (employee?.task?.status != "Approved" && employee?.task?.status != "Completed") {
                        const timerData = getTimerState(employeeId, employee?.task?.id)
                        if (user?.role?.name !== "hr_senior") {
                            return {
                                value: employee?.users?.some((u) => u?.id === user?.id)
                                    ? (timerData?.taskId === employee?.task?.id ? timerData?.status : '')
                                    : '--',
                                type: 'taskstartstop',
                            };
                        }

                        const assignedUsers = employee?.users || [];
                        if (assignedUsers?.length > 1) {
                            return {
                                value: '--',
                                type: 'taskstartstop'
                            }

                        }
                        const latestTimer = allTimers?.find(timer => timer?.state != "stopped" && timer?.employee_id == employeeId);

                        return {
                            value: latestTimer?.state,
                            type: 'taskstartstop',
                        };
                    } else {
                        return {
                            value: '--',
                            type: 'taskstartstop'
                        }
                    }
                })(),

                Time: (() => {
                    let totalElapsed = 0;
                    let isRunning = false;

                    const activeTimers = allTimers?.filter(
                        timer => timer?.state !== "stopped" && timer?.task_id === employee?.task?.id
                    ) || [];
                    const assignedUsers = employee?.users || [];
                    if (assignedUsers?.length > 1) {
                        if (activeTimers?.length > 1) {
                            return {
                                value: "2 Active Timers",
                                type: 'emptasktimer'
                            }
                        }

                        else if (activeTimers?.length == 1) {
                            return {
                                value: "1 Active Timer",
                                type: 'emptasktimer'
                            }
                        }
                    }

                    allTimers?.forEach(timer => {
                        if (timer?.state !== "stopped") {

                            const history = typeof timer?.action_history === 'string'
                                ? JSON.parse(timer?.action_history)
                                : timer?.action_history || [];

                            for (let i = 0; i < history.length; i++) {
                                const action = history[i];
                                const next = history[i + 1];

                                if ((action.action === 'start' || action.action === 'resume')) {
                                    const start = new Date(action.time).getTime();

                                    if (next && (next.action === 'pause' || next.action === 'stop')) {
                                        const stop = new Date(next.time).getTime();
                                        isRunning = true;
                                        totalElapsed += Math.floor((stop - start) / 1000);
                                    } else {
                                        isRunning = true;
                                        totalElapsed += Math.floor((Date.now() - start) / 1000);
                                    }
                                }
                            }
                        }
                    });

                    const h = String(Math.floor(totalElapsed / 3600)).padStart(2, '0');
                    const m = String(Math.floor((totalElapsed % 3600) / 60)).padStart(2, '0');
                    const s = String(totalElapsed % 60).padStart(2, '0');
                    const formattedTime = (!isRunning && totalElapsed == 0) ? '--' : `${h}:${m}:${s}`;
                    const type = (!isRunning && totalElapsed == 0) ? 'emptext' : 'emptasktimer';
                    return {
                        value: formattedTime,
                        type: type
                    };
                })(),
                "Task": {
                    value: employee?.task?.title,
                    type: "text"
                },
                "Project": {
                    value: employee?.task?.project?.name,
                    type: "text"
                },
                "Due Date": {
                    value: employee?.task?.due_date || '--',
                    type: "date",
                },
                "Hours Logged": {
                    value: totalHoursLogged === "0h 0m 0s" ? '0s' : totalHoursLogged,
                    type: "text"
                },
                "Assigned To": {
                    value: employee?.users?.map(user => ({
                        name: user?.name,
                        src: user?.profile_pic?.data ? `data:image/png;base64,${btoa(String.fromCharCode(...new Uint8Array(user?.profile_pic?.data)))}` : '',
                        id: user?.id,
                        isEmployeeTaskPage: true
                    })),
                    type: "share holder",
                },
                "Status": {
                    value: employee?.task?.status,
                    type: 'status_option'
                },
                "Action": {
                    value: `/employees/view/${employeeId}/task/edit`,
                    value2: `/employees/view/${employeeId}/task/view/${employee?.task?.id}`,
                    value3: employee?.task?.id,
                    value6: `/employees/view/${employeeId}/task/timesheet`,
                    type: "action",
                },
                allData: {
                    ...employee.task,
                    taskTimers: taskTimers,
                    totalHoursLogged: totalHoursLogged,
                    time: time
                },
                user: {
                    ...user
                },
                Start_Date: {
                    value: employee?.task?.start_date
                },
                timerIsRunning: {
                    value: isTimerRunning(
                        employee?.users,
                        user?.id,
                        user?.role?.name,
                        filteredTasks
                    )
                }
            }
        }))
    }, [filteredTasks, updateTaskTimerData])

    const Status = taskStatus?.map((item) => {
        return { value: item?.name, label: item?.name, color: item?.color_code, taskStatus: item?.taskStatus, createdAt: item?.createdAt }
    })

    const Project = project?.map((item) => {
        return {
            label: item?.name,
            value: item?.id
        }
    });

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    const handleXlsxDownload = (Ids) => {
        const excludedFields = ['checkbox', 'Action'];
        const columns = header
            .filter(col => !excludedFields.includes(col.field))
            .map(col => ({
                label: col.field,
                key: col.field
            }));

        const selectedData = inData
            .filter(item => Ids.includes(item.allData?.task.id))
            .map(row => {
                const newRow = {};

                columns.forEach(({ label, key }) => {
                    const cell = row[key];

                    if (!cell) {
                        newRow[label] = '';
                    } else if (key === 'Assigned to' && Array.isArray(cell.value)) {
                        newRow[label] = cell.value.map(person => person.name).join(', ');
                    } else if (Array.isArray(cell.value)) {
                        newRow[label] = cell.value.join(', ');
                    } else {
                        newRow[label] = cell.value ?? '';
                    }
                });

                return newRow;
            });
        exportData({
            data: selectedData,
            columns,
            fileName: 'Employee_Task_Report',
            format: 'xlsx',
        });
        setExportLoading(false)
        setTotalSelectedIds([])
    };

    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === "delete") {
                setDeleteLoading(true);
                await props.deleteInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === "export") {
                setExportLoading(true);
                handleXlsxDownload(ids);
                toast.success("Exported Successfully");
            }
        } catch (error) {
            console.error(error);
        } finally {
            setDeleteLoading(false);
        }
    };

    const applyFilters = ({ status, startDate, endDate, project }) => {

        if (startDate != undefined) setFilteredStartDate(filteredStartDate || startDate);
        if (endDate != undefined) setFilteredEndDate(filteredEndDate || endDate);
        const filtered = inData?.filter((task) => {
            let matchesStatus = true;
            let matchesProject = true;
            let matchesDate = true;

            if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
                setDateStatus(true);

                const itemStartDate = moment(task?.Start_Date?.value).startOf('day');
                const itemDueDate = task?.["Due Date"]?.value
                    ? moment(task?.["Due Date"]?.value).startOf('day')
                    : itemStartDate;

                const filterStart = moment(filteredStartDate || startDate).startOf('day');
                const filterEnd = moment(filteredEndDate || endDate).endOf('day');


                matchesDate =
                    itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
                    itemDueDate.isBetween(filterStart, filterEnd, undefined, '[]');


            }

            if (status && status?.value !== "All") {
                if (status?.value == "Hide Completed Task") {
                    matchesStatus = task?.Status?.value?.toLowerCase() !== "completed";
                } else {
                    matchesStatus = task?.Status?.value?.toLowerCase() == status?.value?.toLowerCase();
                }
            }

            if (project) {
                matchesProject = task?.Project?.value?.toLowerCase() == project?.label?.toLowerCase();
            }
            return matchesStatus && matchesProject && matchesDate;
        });
        setFilteredData(filtered);
        updateColumns(filtered, project?.value || null);
    };
    useEffect(() => {
        if (inData?.length) {
            applyFilters({ status: initialState.status, project: initialData.project });
        }
    }, [inData]);

    const handleClear = () => {
        setFilteredStartDate(null);
        setFilteredEndDate(null);
        const defaultStatus = { value: 'Hide Completed Task', label: 'Hide Completed Task' };
        setInitialData({
            project: "",
            status: defaultStatus
        });
        setDateStatus(false);
        setFilteredData([]);
        applyFilters({ status: defaultStatus, project: null });
    }

    useEffect(() => {
        if (totalSelectedIds.length > 0) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    }, [totalSelectedIds]);

    const shouldShowClearButton = () => {
        const hasProject = initialData?.project;
        const hasDateFilter = dateStatus;
        const hasNonDefaultStatus = initialData.status.value && initialData.status.value !== 'Hide Completed Task';

        return hasProject || hasDateFilter || hasNonDefaultStatus;
    };


    const updateColumns = (taskList, projectId = null) => {
        let relevantStatuses;

        if (projectId) {
            relevantStatuses = taskStatus
                ?.filter((status) =>
                    status?.taskStatus?.some((s) => s?.project_id === projectId)
                )
                ?.map((item) => ({
                    name: item?.name,
                    color_code: item?.color_code,
                    createdAt: item?.createdAt
                }));
        }
        else {
            relevantStatuses = []
        }

        const initialColumns = relevantStatuses?.reduce((acc, status) => {
            acc[status?.name] = {
                name: status?.name,
                color_code: status?.color_code,
                createdAt: status?.createdAt,
                items: []
            };
            return acc;
        }, {});

        if (taskList && Array.isArray(taskList)) {
            taskList.forEach((task) => {
                const assignedUser = task?.allData?.taskUserMap?.find(
                    (map) => map.user_id === user?.id
                );

                if (assignedUser) {
                    const status = task?.allData?.status || 'incomplete';

                    const profilePics =
                        task?.allData?.taskUserMap?.map((item) => item?.userTaskMap?.profile_pic) || [];

                    const usernames =
                        task?.allData?.taskUserMap?.map((item) => item?.userTaskMap?.name) || [];

                    if (!initialColumns[status]) return;

                    initialColumns[status]?.items.push({
                        id: task?.allData?.id.toString(),
                        name: task?.allData?.title,
                        profile_pic: profilePics,
                        usernames,
                        project: task?.allData?.project?.name,
                        originalTask: task?.allData,
                        createdAt: initialColumns[status]?.createdAt
                    });
                }
            });
        }

        setColumns(initialColumns);
    };

    const onDragEnd = async (result) => {
        const { source, destination } = result;

        if (!destination) return;

        if (source.droppableId === destination.droppableId && source.index === destination.index)
            return;

        const sourceColumn = columns[source.droppableId];
        const destinationColumn = columns[destination.droppableId];
        const sourceItems = Array.from(sourceColumn.items);
        const destItems = Array.from(destinationColumn.items);

        const [movedItem] = sourceItems.splice(source.index, 1);

        if (source.droppableId === destination.droppableId) {
            sourceItems.splice(destination.index, 0, movedItem);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems,
                },
            });
        } else {
            destItems.splice(destination.index, 0, movedItem);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems,
                },
                [destination.droppableId]: {
                    ...destinationColumn,
                    items: destItems,
                },
            });
        }

        await updateTask(sourceColumn?.items?.[0]?.id, { status: destinationColumn?.name }, true)

        if (initialData?.project) {
            applyFilters({
                status: initialData?.status,
                startDate: filteredStartDate,
                endDate: filteredEndDate,
                project: initialData?.project
            });
        } else {
            updateColumns(task);
        }
    };

    const circleStyle = (color) => ({
        display: 'inline-block',
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: '15px',
    });

    useEffect(() => {
        if (initialData?.project) {
            applyFilters({
                status: initialData?.status,
                project: initialData?.project
            });
        } else {
            updateColumns(task);
        }
    }, [task]);

    return (
        <div className='task-viewEmployee-main'>
            <div className='row'>
                <div className="col-lg-3 col-md-4">
                    <div className="card-type">
                        <Select
                            options={Status?.slice()?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))}
                            styles={{
                                ...customStyle,
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 2,
                                }),
                            }}
                            value={initialData.status}
                            placeholder="Status"
                            onChange={(val) => {
                                setInitialData((prevVal) => ({
                                    ...prevVal,
                                    status: val,
                                }));
                                applyFilters({ status: val, startDate: filteredStartDate, endDate: filteredEndDate, project: initialData?.project });
                            }}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: '#5757fe',
                                    primary: '#5757fe',
                                },
                            })}
                        />
                    </div>
                </div>

                <div className="col-lg-3 col-md-4">
                    <div className="card-type">
                        <CustomCalendar
                            inData={inData}
                            setFilteredData={setFilteredData}
                            selectedStatus={initialData?.status}
                            applyFilters={(params) => { applyFilters(params) }}
                            startDate={filteredStartDate}
                            endDate={filteredEndDate}
                            setStartDate={setFilteredStartDate}
                            setEndDate={setFilteredEndDate}
                            project={initialData?.project}
                        />
                    </div>
                </div>

                <div className="col-lg-3 col-md-4">
                    <div className="card-type">
                        <Select
                            value={initialData.project}
                            onChange={(val) => {
                                setInitialData((prevVal) => ({
                                    ...prevVal,
                                    project: val,
                                }));
                                applyFilters({ status: initialData?.status, startDate: filteredStartDate, endDate: filteredEndDate, project: val });
                            }}
                            options={Project}
                            placeholder={"Project"}
                            styles={customStyle}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: "#5757fe",
                                    primary: "#5757fe",
                                },
                            })}
                        />
                    </div>
                </div>

                <div className='col-lg-12 col-md-12 task-btn-grp'>
                    <div>
                        <RoleWiseFeatureWrapper
                            modules={modules}
                            features={features}
                            user={user}
                            ModuleName={ModulesList.Task}
                            Featur_Name={FeaturesList.Create}>

                            <button
                                className="export-btn"
                                id="exportBtn"
                                // disabled={!checked || exportLoading}
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate(`/employees/view/${employeeId}/task/add`)
                                }}
                            >
                                {/* {exportLoading ? (
                            <Spinner
                            as="span"
                            animation="border"
                            className="custom-spinner"
                            role="status"
                            aria-hidden="true"
                            />
                            ) : (
                                "Export"
                                )} */}
                                Add Task
                            </button>
                        </RoleWiseFeatureWrapper>

                        <button
                            className="export-btn"
                            id="exportBtn"
                            disabled={!checked || exportLoading}
                            onClick={(e) => {
                                e.preventDefault();
                                handleClick(totalSelectedIds, "export");
                            }}
                        >
                            {exportLoading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    className="custom-spinner"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : (
                                "Export"
                            )}
                        </button>
                        {/* {(initialData?.status?.value !== 'Hide Completed Task' || initialData?.project || filteredData?.length > 0 || dateStatus) && ( */}
                        {shouldShowClearButton() && (
                            <button
                                className="export-btn"
                                onClick={handleClear}
                            >Clear</button>
                        )}
                    </div>

                    <div className="navigation_btn">
                        <button
                            className={`btn1 ${activeButton === "task" ? "active" : ""}`}
                            onClick={() => handleClickBtn("task", `/employees/view/${employeeId}/task`)}
                        >
                            <Summery color={activeButton === "task" ? "white" : "black"} bgColor={activeButton === "task" ? "black" : "white"} />
                        </button>
                        <button
                            className={`btn1 ${activeButton === "taskboards" ? "active" : ""}`}
                            onClick={() => handleClickBtn("taskboards", `/employees/view/${employeeId}/task/taskboards`)}
                        >
                            <Drag_Drop color={activeButton === "taskboards" ? "white" : "black"} bgColor={activeButton === "taskboards" ? "black" : "transparent"} />
                        </button>
                    </div>
                </div>

                <div className=' col-lg-12 col-md-12'>
                    {location.pathname === `/employees/view/${employeeId}/task` ? (
                        <Table
                            header={header}
                            data={(initialData?.status || filteredStartDate || filteredEndDate || initialData?.project) ? filteredData : inData}
                            footer={footer}
                            count={count}
                            checked={checked}
                            records={count}
                            showIsView={canView}
                            updateTask={updateTask}
                            showIsTimesheet={true}
                            showIsEdit={canEdit}
                            showIsDelete={canDelete}
                            handleChange={handleChange}
                            totalSelectedIds={totalSelectedIds}
                            defaultParams={params}
                            selectedId={selectedId}
                            TaskStatus={Status}
                            deleteRecord={deleteRecord}
                        />
                    ) : (
                        <div className='drag-drop-div mb-5'>
                            {Object.entries(columns)?.length == 0 ? (
                                <div className="no-records">
                                    <p style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100px",
                                        width: '1000px',
                                        textAlign: "center",
                                        color: "#777",
                                        fontSize: "20px",
                                        fontWeight: "500",
                                    }}>
                                        No records, Please select a project
                                    </p>
                                </div>
                            ) : (
                                <DragDropContext onDragEnd={onDragEnd}>
                                    {Object.entries(columns).sort(([, a], [, b]) => new Date(a.createdAt) - new Date(b.createdAt)).map(([columnId, column]) => (
                                        <Droppable droppableId={columnId} key={columnId}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                    className="drag-drop-droppable"
                                                >
                                                    <h6 className="col-name">
                                                        {<span style={circleStyle(column.color_code)}></span>}
                                                        {column.name}
                                                    </h6>
                                                    <div className="card_main">
                                                        {column.items.map((item, index) => (
                                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                                                {(provided) => (
                                                                    <div
                                                                        className="card"
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        style={{
                                                                            ...provided.draggableProps.style,
                                                                        }}
                                                                    >
                                                                        <p className="card_title">{item?.name}</p>
                                                                        <div className="card_badge"></div>
                                                                        <div className='project'>

                                                                            <svg class="svg-inline--fa fa-layer-group fa-w-16 f-11 text-lightest" width={20} height={20} aria-hidden="true" focusable="false" data-prefix="fa" data-icon="layer-group" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="rgb(179, 177, 177)" d="M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"></path></svg>
                                                                            <div className='project-name'>{item?.project}</div>
                                                                        </div>
                                                                        <div className="card_footer">
                                                                            {/* <div className="card_icons">
                                                                                              <img src={Bookmark} className=" bookmark" />
                                                                                              <img src={DoubleArrowUp} className=" doubleup" />
                              
                                                                                              <div className=" upvote">2</div>
                                                                                          </div> */}
                                                                            <div className="card_icons">
                                                                                <div className="card__id">
                                                                                    <span>{`CD_${item?.id}`}</span>
                                                                                </div>
                                                                                <div className="card__status">
                                                                                    {Array.isArray(item?.profile_pic) && item.profile_pic.some(pic => pic?.data) ? (
                                                                                        item?.profile_pic?.map((pic, index) => {
                                                                                            if (pic?.data) {
                                                                                                const profilePicSrc = `data:image/png;base64,${btoa(
                                                                                                    String.fromCharCode(...new Uint8Array(pic?.data))
                                                                                                )}`;
                                                                                                return (
                                                                                                    <>
                                                                                                        <img key={index} src={profilePicSrc} alt="User" className="card__status-profile_pic" />
                                                                                                        <span className="card__status-dot"></span>
                                                                                                    </>
                                                                                                )
                                                                                            }
                                                                                            return null;
                                                                                        })
                                                                                    ) : (
                                                                                        <>
                                                                                            {Array.isArray(item?.usernames) && item?.usernames?.length > 0 ? (
                                                                                                item?.usernames?.map((name, index) => (
                                                                                                    <span key={index} className="initials">
                                                                                                        {name?.split(" ")?.map(word => word[0]).join("")}
                                                                                                    </span>
                                                                                                ))
                                                                                            ) : (
                                                                                                <span className="initials">N/A</span>
                                                                                            )}
                                                                                            <span className="card__status-dot"></span>
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                    </div>
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    ))}
                                </DragDropContext>
                            )}
                        </div>
                    )
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        filteredTasks: state.taskReducer.filteredTasks,
        user: state.authenticationReducer.user,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
        updateTaskTimerData: state.taskReducer.updateTask,
        taskStatus: state.taskReducer.taskStatus,
        project: state.projectReducer.project,
        task: state.taskReducer.task,

    }
}

export const mapDispatchToProps = (dispatch) => {
    const { employeeId } = useParams();
    return {
        getFilteredTasks: (id) => {
            dispatch(getFilteredTasks(id))
        },
        updateTask: (id, data, showToast) => {
            dispatch(updateTask(id, data, showToast))
        },
        getTaskStatus: () => {
            dispatch(getTaskStatus())
        },
        getprojects: () => {
            dispatch(getprojects())
        },
        getTasks: () => {
            dispatch(getTasks())
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue))
            await dispatch(getFilteredTasks(employeeId))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskEmployees)